import { createPortal } from 'react-dom'

import { cn } from '@/lib/utils'

import { CaseUpdateHistoryPagination } from '../case-update-history-pagination/case-update-history-pagination'
import { CaseUpdateHistoryItem } from './case-update-history-item'
import { Loading } from './loading'
import { useCaseUpdateHistory } from './use-case-update-history'

export const CaseUpdateHistory = () => {
  const {
    caseUpdateHistoryData,
    totalPages,
    currentPage,
    currentPageSize,
    paginationPortalRoot,
    isLoadingData,
    handleChangePage,
    handleChangePageSize,
  } = useCaseUpdateHistory()

  if (isLoadingData) {
    return <Loading />
  }

  if (caseUpdateHistoryData.length === 0) {
    return <p className={cn('text-center text-gray-500', 'py-3')}>No data.</p>
  }

  return (
    <>
      <div>
        <p className={cn('w-full', 'h-[30px]', 'text-right text-xs font-normal text-slate-500', 'pr-5')}>
          Notification Date
        </p>

        <ul>
          {caseUpdateHistoryData.map((data, index) => (
            <li
              key={`${data.messageType}-${data.message}-${data.createdAt}-${index}`}
              className={cn('border-b border-border last-of-type:border-none')}
            >
              <CaseUpdateHistoryItem data={data} />
            </li>
          ))}
        </ul>
      </div>

      {paginationPortalRoot &&
        createPortal(
          <CaseUpdateHistoryPagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={currentPageSize}
            onChangePage={handleChangePage}
            onChangePageSize={handleChangePageSize}
          />,
          paginationPortalRoot
        )}
    </>
  )
}
